module.exports = __webpack_public_path__ + "static/media/point_2.8e9778de.gif";